import React, { useEffect, useState } from 'react';
// @ts-ignore
import './styles.css';
//internal or external components import
import { Box, Typography, Paper, Tab, Tooltip, Avatar, Skeleton } from '@mui/material';
import Textarea from '@mui/joy/Textarea';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { setSnackBarData } from '../../redux/reducers/common';
import { colors } from '../../common/pallette/colors';
import { formatDate, formatDateTime, formatDateTimeToHHmm, genUID } from '../../common/StaticExports';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faClockRotateLeft, faCopy, faTrash } from '@fortawesome/free-solid-svg-icons';
import AlertPopup from '../../components/AlertPopup';
import StatusIndicatorCircleSmall from '../../components/StatusIndicatorCircleSmall';
import { baseUrl } from '../../api/config';
import { ActivityHistoryPopup } from '../../components/ActivityHistoryPopup';
import { Check, MessageSquare, MessageSquareMore, MessageSquareText } from 'lucide-react';
import CircularWithValueLabel from '../../components/CircularProgress';

export const ReportComment = (props: any) => {
    const { manageChange,
            manageSaveComment, 
            tabList,
            selectedTab, 
            deleteComment,
            isDeletable,
            onSiteCriteriaComments,
            criteriaComments,
            handleTabSwitch,
            commentHistory,
            progress } = props
    const onSiteCriteria = useSelector((state:any) => state.evaluation.onSiteCriteria);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const dispatch = useDispatch();
    const [t] = useTranslation();
    const actionDeletePopupInitialData = {
        isOpen: false,
        actionToDelete: null,
        alertMessage: '',
    }
    const [actionDeletePopup, setActionDeletePopup]:any = useState(actionDeletePopupInitialData);
    const [data, setData]:any = useState(null);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    // let firstName:any = null;
    // let lastName:any = null;
    // let avatarPath:any = null;
    const [copyCommentTooltip, setCopyCommentTooltip] = useState('COPY_COMMENT');
  const [isPopupVisible, setIsPopupVisible] = React.useState(false);
  const [anchorPosition, setAnchorPosition] = React.useState<null | HTMLElement>(null);
  const [onSiteCriteriaHistory, setOnSiteCriteriaHistory] = useState<any>([]);
  const drawer = useSelector((state:any) => state.common.drawer);
  const [isLoading, setIsLoading] = useState(true);
    
    const manageSetData = ( tabName:any) => {
        setData(null);
        switch(tabName) {
            case t('SELF_ASSESSMENT'):
                setData({
                            comment: criteriaComments?.selfAssessmentComment,
                            updatedDate: criteriaComments?.selfAssessmentCreatedDate,
                            avatarPath: criteriaComments?.selfAssessmentUserAvatarPath,
                            firstName: criteriaComments?.selfAssessmentCreatedUserFirstName,
                            lastName: criteriaComments?.selfAssessmentCreatedUserLastName,
                            commentUpdatedUsers: criteriaComments?.saCommentUpdatedUsers
                        });
                break;
            case t('OFF_SITE'):
                setData({
                            comment: criteriaComments?.offSiteComment,
                            updatedDate: criteriaComments?.offSiteCreatedDate,
                            avatarPath: criteriaComments?.offSiteUserAvatarPath,
                            firstName: criteriaComments?.offSiteCreatedUserFirstName,
                            lastName: criteriaComments?.offSiteCreatedUserLastName,
                            commentUpdatedUsers: criteriaComments?.offSiteCommentUpdatedUsers
                        });
                break;
            case t('REPORTS'):
                setData({
                            comment: criteriaComments?.finalReportComment,
                            updatedDate: criteriaComments?.finalReportCreatedDate,
                            avatarPath: criteriaComments?.finalReportUserAvatarPath,
                            firstName: criteriaComments?.finalReportCreatedUserFirstName,
                            lastName: criteriaComments?.finalReportCreatedUserLastName,
                            commentUpdatedUsers: criteriaComments?.finalReportCommentUpdatedUsers
                        });
                break;
            case t('LICENCE_SELF_ASSESSMENT'):
                setData({
                            comment: criteriaComments?.licenceSAComment,
                            updatedDate: criteriaComments?.licenceSAUpdatedDate,
                            avatarPath: null,
                            firstName: null,
                            lastName: null,
                            commentUpdatedUsers: null
                        });
                break;
            case t('LICENCE_EVALUATION'):
                setData({
                            comment: criteriaComments?.licenceEvaluationComment,
                            updatedDate: criteriaComments?.licenceEvaluationUpdatedDate,
                            avatarPath: null,
                            firstName: null,
                            lastName: null,
                            commentUpdatedUsers: null
                        });
                break;
        }
        setTimeout(() => {
            setIsLoading(false);
        }, 2000);
    }

    useEffect(() => {
        setIsLoading(true);
        selectedTab && manageSetData(selectedTab);
    }, [selectedTab, criteriaComments]);

    const handleChange = (event: React.SyntheticEvent, newValue: any) => {
        setData(null);
        handleTabSwitch(newValue);
    };

    const processDeleteComment = (e:any, dataToDelete:any) => {
        setAnchorEl(e.currentTarget);
        const tempAlertPopup:any = {
            isOpen: true,
            alertMessage: t('DELETE_COMMENT_CONFIRMATION'),
            dataToDelete: dataToDelete,
        }
        setActionDeletePopup(tempAlertPopup);
    }

    const manageHandleClose = (isConfirm:any) => {
        setAnchorEl(null);
        if (isConfirm) {
            selectedTab == t('ON_SITE') ? deleteComment(selectedTab, actionDeletePopup?.dataToDelete) : deleteComment(selectedTab, null);
        }
        setActionDeletePopup(actionDeletePopupInitialData);   
    }

    const fetchStatus = (statusStr: any, clubStatusStr: any) => {
        const tClubStatusStr = t(clubStatusStr);
        if (statusStr == tClubStatusStr) {
            return 1;
        } else {
            switch(statusStr) {
            case t('SELF_ASSESSMENT'):
                return 2;
            case t('OFF_SITE'):
                if (tClubStatusStr == t('ON_SITE') || tClubStatusStr == t('INTERIM_REPORT') || tClubStatusStr == t('FINAL_REPORT')) return 2;
                if (tClubStatusStr == t('SELF_ASSESSMENT')) return 0;
                break;
            case t('ON_SITE'):
                if (tClubStatusStr == t('INTERIM_REPORT') || tClubStatusStr == t('FINAL_REPORT')) return 2;
                if (tClubStatusStr == ('SELF_ASSESSMENT') || tClubStatusStr == t('OFF_SITE')) return 0;
                break;
            case t('REPORTS'):
                if (tClubStatusStr == t('INTERIM_REPORT') || tClubStatusStr == t('FINAL_REPORT')) return 1;
                if (tClubStatusStr == ('SELF_ASSESSMENT') || tClubStatusStr == t('OFF_SITE') || tClubStatusStr == t('ON_SITE')) return 0;
                break;
            }
        }
    }

    const manageCopyClick = (commentToCopy:any) => {
        navigator.clipboard.writeText(commentToCopy);
        const warningData:any = {isOpen: true, severity: 'success', message: t('COMMENT_COPIED')};
        dispatch(setSnackBarData(warningData));
        setCopyCommentTooltip('COPIED');
    }

    const handleHistoryButtonClick = (event:any) => {
        setAnchorPosition(event.currentTarget);
        setIsPopupVisible(true);
    };

    const fetchSessionName = (session:any) => {
        const sessionData = onSiteCriteria.find((item:any) => item.id == session.sessionId);
        if (sessionData) {
            return sessionData?.name;
        } else {
            return '-'
        }
    }

      const getCircleStyle = (station:any, index:any) => {
        const progress = fetchProgress(station);
        const isActive = station === selectedTab;
        const isCompleted = progress === 100;

        let baseStyle:any = {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: 'bold',
        position: 'relative',
        transition: 'all 0.3s ease',
        };

        if (isCompleted) {
        baseStyle.backgroundColor = '#4CAF50';
        baseStyle.border = '2px solid #4CAF50';
        baseStyle.color = 'white';
        } else if (isActive) {
        baseStyle.backgroundColor = '#2196F3';
        baseStyle.border = '2px solid #2196F3';
        baseStyle.color = 'white';
        } else {
        baseStyle.backgroundColor = '#fff';
        baseStyle.border = '2px solid #e0e0e0';
        baseStyle.color = '#666';
        }

        return baseStyle;
    };

  const getProgressRing = (station:any, index:any) => {
    const progress = fetchProgress(station);
    const isCompleted = progress === 100;
    if (progress === 0 || isCompleted) return null;

    const radius = 19;
    const strokeWidth = 2;
    const circumference = radius * 2 * Math.PI;
    const strokeDasharray = `${circumference} ${circumference}`;
    const strokeDashoffset = circumference - (progress / 100) * circumference;

    return (
      <svg
        style={{
          position: 'absolute',
          top: '-1px',
          left: '-1px',
          width: '42px',
          height: '42px',
          transform: 'rotate(-90deg)',
          pointerEvents: 'none',
        }}
      >
        <circle
          stroke={station === selectedTab ? '#fff' : "#2196F3"}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={strokeDasharray}
          style={{ strokeDashoffset }}
          r={radius}
          cx="21"
          cy="21"
        />
      </svg>
    );
  };

  const fetchProgress = (station:any) => {
    switch(station) {
        case t('ON_SITE'):
            return progress?.onSiteProgress || 0;
        case t('REPORTS'):
            return progress?.reportsProgress || 0;
        case t('SELF_ASSESSMENT'):
            return progress?.selfAssessmentProgress || 0;
        case t('OFF_SITE'):
            return progress?.offSiteProgress || 0;
        case t('LICENCE_SELF_ASSESSMENT'):
            return progress?.selfAssessmentProgress || 0;
        case t('LICENCE_EVALUATION'):
            return progress?.evaluationProgress || 0;
    }
  }

  // MUI-style Tab component
  const Tab = ({ value, station, index, onClick, selected }:any) => (
    <div
      role="tab"
      aria-selected={selected}
      onClick={(e) => onClick(e, value)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
        minWidth: 'auto',
        padding: 0,
        backgroundColor: 'transparent',
        border: 'none',
        outline: 'none',
      }}
    >
      <div
        style={getCircleStyle(station, index) as React.CSSProperties}
      >
        {getProgressRing(station, index)}
        {fetchProgress(station) === 100 ? (
          <Check size={20} />
        ) : (
          <span>
            {
                <MessageSquareText size={20} color={station === selectedTab ? '#fff' : '#2196F3'} />
            }
          </span>
        )}
      </div>
      
      <div style={{ marginTop: '8px', textAlign: 'center', minHeight: '40px', minWidth: '80px' }}>
        <div 
          style={{ 
            fontWeight: '700',
            color: station === selectedTab ? '#2196F3' : '#333',
            fontSize: '12px',
            lineHeight: '1.2',
            marginBottom: '2px'
          }}
        >
          {station}
        </div>
      </div>
    </div>
  );

  // MUI-style Tabs container
  const Tabs = ({ value, onChange, children }:any) => (
    <div
      role="tablist"
      style={{
        display: 'flex',
        position: 'relative',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        zIndex: 3,
        width: '800px'
      }}
    >
      {children}
    </div>
  );

  const calculateProgressWidth = (length = tabList.length) => {
    switch(length) {
        case 4:
            return (tabList.indexOf(selectedTab) === 0) ? '0%' : 
                    tabList.indexOf(selectedTab) === (tabList.length - 1) ? 
                    '100%': tabList.indexOf(selectedTab) == (tabList.length - 2) ? '64%':
                    `calc(${(tabList.indexOf(selectedTab) / (tabList.length - 1)) * 100}%)`;
        case 2:
            return (tabList.indexOf(selectedTab) === 0) ? '0%' : '86%';
    }
  }

    return(
        <React.Fragment>
            <Paper className={'ReportCommentWrapper'} elevation={1} sx={{ height: '100%' }}>
                <Box sx={{ height: 'calc(100% - 32px)' }}>
                    <ActivityHistoryPopup data={selectedTab == t('ON_SITE') ? onSiteCriteriaHistory : commentHistory} 
                    isVisible={isPopupVisible}
                    onClose={() => {setIsPopupVisible(false); setAnchorPosition(null);}}
                    anchorElement={anchorPosition} />
                    <AlertPopup alertMessage={actionDeletePopup?.alertMessage} isOpen={actionDeletePopup?.isOpen} handleClose={(isDelete:any) => {manageHandleClose(isDelete)}} anchor={anchorEl} />
                    <TabContext value={selectedTab}>
                        <Box className={'commentBoxHeader'}>
                            {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}> */}
                            <div style={{ position: 'relative', marginBottom: '16px' }}>
                                {
                                    tabList && tabList.length > 1 &&
                                    <>
                                    {/* Continuous horizontal line behind all circles */}
                                    <div 
                                    style={{
                                        position: 'absolute',
                                        top: '19px',
                                        left: drawer == 'Licence' ? '62px' : '27px',
                                        right: drawer == 'Licence' ? '38px' : '20px',
                                        height: '2px',
                                        backgroundColor: '#e0e0e0',
                                        zIndex: 1,
                                    }}
                                    />
                                    
                                    {/* Filled portion of the line up to active tab */}
                                    <div 
                                    style={{
                                        position: 'absolute',
                                        top: '19px',
                                        left: drawer == 'Licence' ? '62px' : '27px',
                                        width: calculateProgressWidth(),
                                        height: '2px',
                                        backgroundColor: '#2196F3',
                                        transition: 'width 0.3s ease',
                                        zIndex: 2,
                                    }}
                                    />
                                    </>
                                }
                                
                                {/* MUI-style Tabs structure */}
                                <Tabs value={selectedTab} onChange={handleChange}>
                                {tabList.map((station:any, index:any) => (
                                    <Tab
                                    key={station}
                                    value={station}
                                    station={station}
                                    index={index}
                                    onClick={handleChange}
                                    selected={station === selectedTab}
                                    />
                                ))}
                                </Tabs>
                            </div>
                        </Box>
                        <TabPanel value={selectedTab} className='tabPanelComments' sx={{ mt:'10px' }}>
                            {
                                selectedTab == t('ON_SITE') ?
                                (
                                    !isLoading ?
                                    onSiteCriteriaComments?.map((item:any) => {
                                        return(
                                            <Box className='commentBoxContainer' sx={{ height: 'auto', mb: '40px' }}>
                                                <Box sx={{ width: '100%' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <CircularWithValueLabel progress={item?.progress || 0} />
                                                        <Typography sx={{ fontSize: 14, textAlign: 'left', ml: '10px', fontWeight: 700}}>
                                                            {fetchSessionName(item)}
                                                        </Typography>
                                                    </Box>
                                                    <JoyCssVarsProvider>
                                                        <Textarea 
                                                        sx={{ borderRadius: '6px',
                                                            mt: 1,
                                                            backgroundColor: colors.grey.bright, 
                                                            border: 0, 
                                                            minHeight: '80px',
                                                            height: 'auto', 
                                                            color: colors.black.dark,
                                                            // TO DISPLAY THE TEXT IN BLACK COLOR EVEN IF THE TEXT AREA IS DISABLED
                                                            '&.Mui-disabled': {
                                                                '--Textarea-disabledColor': 'black',
                                                                color: 'black',
                                                            },}} 
                                                        onChange={(e) => {manageChange(e.target.value, item)}} 
                                                        onBlur={() => {manageSaveComment(item)}}
                                                        placeholder='Add a comment' 
                                                        value={item?.comment}
                                                        />
                                                    </JoyCssVarsProvider>
                                                    <Box sx={{ display: "flex", mb: '5px', mt: '10px' }}>
                                                        {
                                                            item && 
                                                            item.comment &&
                                                            item?.updatedUserFirstName != null &&
                                                            item?.updatedUserFirstName != '' &&
                                                            <>
                                                            <Avatar sx={{width: 20, height: 20, fontSize: 8}} src={item?.userAvatarPath ? `${baseUrl}/Content${item?.userAvatarPath}` : ''} />
                                                            <Typography className='fs12 fw700 mtbAuto ml5 mr5'>{(item?.updatedUserFirstName != '' && item?.updatedUserLastName != '') ? `${item?.updatedUserFirstName} ${item?.updatedUserLastName}` : 'Unknown'}</Typography>
                                                            <Typography className='fs12 mtbAuto'>{item.commentCreatedDate ? formatDateTime(item.commentCreatedDate) : '-'}</Typography>
                                                            </>
                                                        }
                                                        <Box
                                                        sx={{
                                                            mr: '10px',
                                                            ml: 'auto',
                                                            display: 'flex',
                                                        }}>
                                                            {
                                                                (selectedTab == t('ON_SITE') && item?.commentHistory && item?.commentHistory?.length > 0) &&
                                                                <Tooltip title={t('COMMENT_HISTORY')} arrow placement='top'>
                                                                    <FontAwesomeIcon className='icon mtbAuto mr10' style={{ width: '20px', height: '20px'}} icon={faClockRotateLeft} onClick={(e:any) => {handleHistoryButtonClick(e); setOnSiteCriteriaHistory(item?.commentHistory)}} />
                                                                </Tooltip>
                                                            }
                                                            {
                                                                item && 
                                                                item.comment &&
                                                                <Tooltip title={t(copyCommentTooltip)} arrow placement='top'>
                                                                    <FontAwesomeIcon className='icon mtbAuto mr10' style={{ width: '20px', height: '20px'}} icon={faCopy} onClick={() => {manageCopyClick(item?.comment)}} onMouseLeave={() => { setCopyCommentTooltip('COPY_COMMENT') }} />
                                                                </Tooltip>
                                                            }
                                                            {
                                                                item && 
                                                                item.comment &&
                                                                isDeletable &&
                                                                <Tooltip title='Delete' arrow placement='top'>
                                                                    <FontAwesomeIcon 
                                                                    onClick={(e:any) => {processDeleteComment(e, item)}} 
                                                                    className={'icon mr10 deleteIcon fs18'}
                                                                    icon={faTrash}/>
                                                                </Tooltip>
                                                            }
                                                        </Box>
                                                    </Box>
                                                    {
                                                        item && item.comment &&
                                                        item?.commentUpdatedUsers &&
                                                        item?.commentUpdatedUsers.map((d:any) => {
                                                            return (
                                                                <Typography sx={{ fontSize: 10, color: colors.grey.dark, textAlign: 'left', mt: '5px', ml: '30px' }} >
                                                                    {`Updated on ${formatDate(d?.updatedDate)} by ${d?.firstName} ${d?.lastName} at ${formatDateTimeToHHmm(d?.updatedDate)}`}
                                                                </Typography>
                                                            )       
                                                        })
                                                    }
                                                </Box>
                                            </Box>
                                        )
                                    }) :
                                    // LOADING SKELETON for  on-site
                                    <Box sx={{ width: '100%' }}>
                                        <Box sx={{ display: 'flex', mb: '10px' }}>
                                            <Skeleton variant="circular" width={'24px'} height={'24px'} />
                                            <Skeleton variant="text" width={'280px'} sx={{ ml: '10px' }} />
                                        </Box>
                                        <Skeleton variant="rectangular" width={'100%'} height={'80px'} />
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Box sx={{ display: 'flex', mt: '10px' }}>
                                                <Skeleton variant="circular" width={'24px'} height={'24px'} />
                                                <Skeleton variant="text" width={'280px'} sx={{ ml: '10px' }} />
                                            </Box>
                                            <Box sx={{ display: 'flex', mt: '10px', justifyContent: 'flex-end' }}>
                                                <Skeleton variant="circular" width={'24px'} height={'24px'} />
                                                <Skeleton variant="circular" width={'24px'} height={'24px'} sx={{ ml: '10px' }} />
                                            </Box>
                                        </Box>
                                    </Box>
                                )
                                :
                                <Box className='commentBoxContainer' sx={{ height: '100%' }}>
                                    {
                                        !isLoading ?
                                        <Box sx={{ width: '100%' }}>
                                            <JoyCssVarsProvider>
                                                <Textarea 
                                                sx={{ borderRadius: '6px',
                                                    mt: 1,
                                                    backgroundColor: colors.grey.bright, 
                                                    border: 0, 
                                                    minHeight: '80px',
                                                    height: 'auto', 
                                                    color: colors.black.dark,
                                                    // TO DISPLAY THE TEXT IN BLACK COLOR EVEN IF THE TEXT AREA IS DISABLED
                                                    '&.Mui-disabled': {
                                                        '--Textarea-disabledColor': 'black',
                                                        color: 'black',
                                                    },}} 
                                                onChange={(e) => {manageChange(e.target.value, null)}} 
                                                onBlur={() => {manageSaveComment(null)}}
                                                placeholder='Add a comment' 
                                                disabled={!isDeletable}
                                                value={data?.comment || ''}/>
                                            </JoyCssVarsProvider>
                                            <Box sx={{ display: "flex", mb: '5px', mt: '10px' }}>
                                                {
                                                    data && data.comment && 
                                                    data?.comment != '' &&
                                                    data?.firstName != null &&
                                                    data?.firstName != '' &&
                                                    <>
                                                    <Avatar sx={{width: 20, height: 20, fontSize: 8}} src={data?.avatarPath ? `${baseUrl}/Content${data?.avatarPath}` : ''} />
                                                    <Typography className='fs12 fw700 mtbAuto ml5 mr5'>{(data?.firstName != '' && data?.lastName != '') ? `${data?.firstName} ${data?.lastName}` : 'Unknown'}</Typography>
                                                    <Typography className='fs12 mtbAuto'>{data.updatedDate ? formatDateTime(data.updatedDate) : '-'}</Typography>
                                                    </>
                                                }
                                                <Box
                                                sx={{
                                                    mr: '10px',
                                                    ml: 'auto',
                                                    display: 'flex',
                                                }}>
                                                    {
                                                        (commentHistory && commentHistory.length > 0) &&
                                                        <Tooltip title={t('COMMENT_HISTORY')} arrow placement='top'>
                                                            <FontAwesomeIcon className='icon mtbAuto mr10' style={{ width: '20px', height: '20px'}} icon={faClockRotateLeft} onClick={(e:any) => {handleHistoryButtonClick(e)}} />
                                                        </Tooltip>
                                                    }
                                                    {
                                                        data && data.comment && 
                                                        data?.comment != '' &&
                                                        <Tooltip title={t(copyCommentTooltip)} arrow placement='top'>
                                                            <FontAwesomeIcon className='icon mtbAuto mr10' style={{ width: '20px', height: '20px'}} icon={faCopy} onClick={() => {manageCopyClick(data?.comment)}} onMouseLeave={() => { setCopyCommentTooltip('COPY_COMMENT') }} />
                                                        </Tooltip>
                                                    }
                                                    {
                                                        data && data.comment && 
                                                        data?.comment != '' &&
                                                        isDeletable &&
                                                        <Tooltip title='Delete' arrow placement='top'>
                                                            <FontAwesomeIcon 
                                                            onClick={(e:any) => {processDeleteComment(e, null)}} 
                                                            className={'icon mr10 deleteIcon fs18'}
                                                            icon={faTrash}/>
                                                        </Tooltip>
                                                    }
                                                </Box>
                                            </Box>
                                            {
                                                data && data.comment &&
                                                data?.commentUpdatedUsers &&
                                                data?.commentUpdatedUsers.map((item:any) => {
                                                    return (
                                                        <Typography sx={{ fontSize: 10, color: colors.grey.dark, textAlign: 'left', mt: '5px', ml: '30px' }} >
                                                            {`Updated on ${formatDate(item?.updatedDate)} by ${item?.firstName} ${item?.lastName} at ${formatDateTimeToHHmm(item?.updatedDate)}`}
                                                        </Typography>
                                                    )       
                                                })
                                            }
                                        </Box> :
                                        // LOADING SKELETON for all tabs except on-site
                                        <Box sx={{ width: '100%' }}>
                                            <Skeleton variant="rectangular" width={'100%'} height={'80px'} />
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <Box sx={{ display: 'flex', mt: '10px' }}>
                                                    <Skeleton variant="circular" width={'24px'} height={'24px'} />
                                                    <Skeleton variant="text" width={'280px'} sx={{ ml: '10px' }} />
                                                </Box>
                                                <Box sx={{ display: 'flex', mt: '10px', justifyContent: 'flex-end' }}>
                                                    <Skeleton variant="circular" width={'24px'} height={'24px'} />
                                                    <Skeleton variant="circular" width={'24px'} height={'24px'} sx={{ ml: '10px' }} />
                                                </Box>
                                            </Box>
                                        </Box>
                                    }
                                </Box>
                            }
                        </TabPanel>
                        {/* <TabPanel value='CHAT' sx={{ p: 0, height: 'calc(100% - 55.25px)' }}>
                            <Box className='chatWrapper' sx={{ minHeight: '145px', height: '100%' }}>
                                <ChatBox />
                            </Box>
                        </TabPanel> */}
                    </TabContext>
                </Box>
            </Paper>
        </React.Fragment>
    )
}